const generateStaticMap = (config) => {
  const { markers, width, height, googleMapsKey, zoom, center, poi } = config;
  const markersString = markers == null ? void 0 : markers.reduce((acc, marker) => {
    const { icon, coordinates } = marker;
    return acc + `&markers=icon:${icon}|${coordinatesToText(coordinates)}`;
  }, "");
  const baseUrl = "https://maps.googleapis.com/maps/api/staticmap";
  const commonParameters = `size=${width}x${height}&key=${googleMapsKey}`;
  const zoomParameter = zoom ? `&zoom=${zoom}` : "";
  const centerParameter = center ? `&center=${coordinatesToText(center)}` : "";
  const poiParameter = !poi ? `&style=feature:poi|visibility:off` : "";
  return `${baseUrl}?${commonParameters}${markersString != null ? markersString : ""}${zoomParameter}${centerParameter}${poiParameter}`;
};
const coordinatesToText = (coordinates) => {
  if (!coordinates) {
    return void 0;
  }
  const { lat, lng } = coordinates;
  return `${lat},${lng}`;
};

export { coordinatesToText, generateStaticMap };
//# sourceMappingURL=bundle.esm3.js.map
